import { gql } from '@apollo/client';
export const getInviteComposers = gql `
  query GetInviteComposers($where: WhereComposerInput) {
    composers(where: $where) {
      id
      metadata {
        name
        marketLocaleCode
      }
    }
  }
`;
